import { z } from "zod";
import { Perfil } from "./base.ts";

/** Manifesto: o que o app consulta para saber se precisa baixar algo. */
export const Manifesto = z.object({
  /** Hash da release, derivado das versões das coleções. */
  versao: z.string(),
  publicadaEm: z.string(),
  /** Versão (hash) de cada coleção. O app só baixa as que mudaram. */
  colecoes: z.record(z.string(), z.string()),
});
export type Manifesto = z.infer<typeof Manifesto>;

export const PLANOS = ["padrao", "estudante"] as const;
export const Plano = z.enum(PLANOS);

export const Acesso = z.object({
  ativo: z.boolean(),
  plano: Plano.nullable(),
  /** Até quando a sessão vale sem nova confirmação, em ms desde a época. */
  expiraEm: z.number(),
  motivo: z.enum(["compra", "manual", "equipe"]).nullable(),
  /** Módulo adicional de mapas mentais comprado. */
  mapas: z.boolean().default(false),
});
export type Acesso = z.infer<typeof Acesso>;

export const Sessao = z.object({
  usuario: z.object({ id: z.string(), email: z.string(), nome: z.string().nullable(), perfil: Perfil.nullable() }),
  acesso: Acesso,
  /** Ausente sem acesso ativo ou quando ainda não há release publicada. */
  release: Manifesto.nullable(),
});
export type Sessao = z.infer<typeof Sessao>;
